import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {
  Backdrop,
  Box,
  CircularProgress,
  InputBase,
  Grid,
  Typography
} from '@material-ui/core';

import BoxCenter from './BoxCenter';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(theme => ({
  backDrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    pointerEvents: 'all',
    zIndex: 2
  },
  bg: {
    alignItems: 'center',
    backgroundImage: 'url(images/login/framing_4.png)',
    display: 'flex',
    flexDirection: 'column',
    height: 275,
    justifyContent: 'center',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(4),
    width: 400
  },
  confirmButton: {
    backgroundColor: 'transparent',
    backgroundImage: 'url(images/login/btn_green_L_normal.png)',
    backgroundSize: 'contain',
    border: 'none',
    color: 'white',
    height: 71,
    paddingBottom: 30,
    outline: 'none',
    fontFamily: 'PJ_WangNgan',
    fontSize: 'xx-large',
    width: 120,
    '&:active': {
      paddingBottom: 25,
      backgroundImage: 'url(images/login/btn_green_L_active.png)'
    }
  },
  root: {
    transform: ({ scale }) => `scale(${window.devicePixelRatio * scale})`,
    pointerEvents: 'all'
  },
  textField: {
    backgroundImage: 'url(images/login/framing_3.png)',
    height: 50,
    padding: theme.spacing(1),
    width: 350
  }
}));
const initialState = {
  password: '',
  confirmPassword: ''
};
const ResetPassword = (
  { onSubmit, scale, error, loading, onBackToLogin },
  ref
) => {
  const { backDrop, bg, confirmButton, root, textField } = useStyles({ scale });
  const [form, setForm] = useState(initialState);
  const [errorMessage, setErrorMessage] = useState(error);
  const [success, setSuccess] = useState(false);
  useImperativeHandle(ref, () => ({
    sendSuccess: () => {
      setSuccess(true);
    },
    setError: err => {
      setErrorMessage(err);
    }
  }));
  const handleTextFieldChange = ({ target }) => {
    setForm({ ...form, [target.name]: target.value });
  };
  const handleSubmit = () => {
    if (success) {
      onBackToLogin();
    } else {
      if (form.password === form.confirmPassword) {
        if (form.password.length < 6 || form.password.length > 12) {
          console.log(
            'Your password must contain between 6 and 12 characters. Please try again.'
          );
          setErrorMessage('รหัสผ่านของคุณจะต้องมีอย่างน้อย 6 ตัวอักษร');
        } else {
          onSubmit(form.password);
        }
      } else {
        setErrorMessage('รหัสผ่านไม่ตรงกัน');
      }
    }
  };
  return (
    <BoxCenter>
      <Box
        width={400}
        height={600}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        className={root}
      >
        <Grid container spacing={2} justify="center" alignItems="flex-start">
          <Grid item>
            <div className={bg}>
              {success ? (
                <Typography variant="h5">
                  รหัสผ่านได้ถูกแก้ไขแล้ว กรุณาล็อกอินใหม่อีกครั้ง
                </Typography>
              ) : (
                <>
                  <Box position="absolute" right={25} top={160}>
                    <Typography variant="body1" color="error" align="center">
                      {errorMessage}
                    </Typography>
                  </Box>
                  <Box m={1}>
                    <Typography variant="h5">รหัสผ่าน</Typography>
                    <InputBase
                      className={textField}
                      type="password"
                      name="password"
                      value={form.password}
                      onChange={handleTextFieldChange}
                      placeholder="password"
                      inputProps={{
                        maxLength: 12
                      }}
                    />
                  </Box>
                  <Box m={1}>
                    <Typography variant="h5">กรอกรหัสอีกครั้ง</Typography>
                    <InputBase
                      className={textField}
                      type="password"
                      name="confirmPassword"
                      value={form.confirmPassword}
                      onChange={handleTextFieldChange}
                      placeholder="password"
                      inputProps={{
                        maxLength: 12
                      }}
                    />
                  </Box>
                </>
              )}
            </div>
          </Grid>
          <Grid item>
            <Box display="flex" flexDirection="column">
              <button onClick={handleSubmit} className={confirmButton}>
                {success ? 'กลับ' : 'ตกลง'}
              </button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Backdrop className={backDrop} open={loading}>
        <CircularProgress />
      </Backdrop>
    </BoxCenter>
  );
};
export default forwardRef(ResetPassword);
